import moment from 'moment';

interface DateFormatObject {
  [key: string]: number;
}

export const parseDateFromString = (input: string, format: string) => {
  const dateFormat = format || 'yyyy-mm-dd';
  const parts = input.match(/(\d+)/g);
  let i = 0;
  const formatObject: DateFormatObject = {};

  // extract date-part indexes from the format
  dateFormat.replace(/(yyyy|dd|mm)/g, (part) => {
    formatObject[part] = i++;
    return part; // Return the matched part to maintain the string
  });

  if (!parts) return null;
  return new Date(parseInt(parts[formatObject.yyyy], 10), parseInt(parts[formatObject.mm], 10) - 1, parseInt(parts[formatObject.dd], 10));
};

export const calculateAge = (dateOfBirth: string) => {
  const birthday = moment(dateOfBirth, 'DD/MM/YYYY').toDate();
  const ageDifMs = Date.now() - birthday.getTime();
  const ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

export const checkDatesAreSameDay = (date1: Date, date2: Date) => {
  if (date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate()) {
    return true;
  }
  return false;
};

export const getDayDifference = (startDate: Date, endDate: Date) => {
  const difference = startDate.getTime() - endDate.getTime();
  const days = Math.ceil(difference / (1000 * 3600 * 24));
  return days;
};

export const getMonthDifference = (startDate: Date, endDate: Date) =>
  endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear());

export function formatTimestampToDate(timestamp: number | undefined) {
  if (!timestamp) {
    return '';
  }

  return moment(new Date(timestamp * 1000)).format('Do MMMM Y');
}
